import * as $ from 'jquery'

require('jquery-validation');
import './right-sideBar.js';
import './loader.js';
import './custom-select.js';
import './form-validation.js';
import './menu.js';
import './slider';
import './popups';
import './form-adder';
import {Fancybox} from "@fancyapps/ui";

if (route().current('web.contact') && window.innerWidth <= 1360) {
    document.body.style.height = '100%';
    document.getElementById("header").style.position = "fixed";
    document.body.style.overflowY = 'scroll';
    document.getElementById("footer").style.position = "unset";
}


if (!route().current('web.home') && document.location.pathname !== '/contact') {
    document.body.style.height = '100%';
    document.getElementById("header").style.position = "fixed";
    document.body.style.overflowY = 'scroll';
    document.getElementById("footer").style.position = "unset";
}
Fancybox.bind("[data-fancybox]", {});

const washingWrapperCardTops = document.querySelectorAll('.washing-wrapper__card-top');

washingWrapperCardTops.forEach((washingWrapperCardTop) => {
    const images = washingWrapperCardTop.querySelectorAll('img');
    const totalImages = images.length;
    const className = `photo-${totalImages}`;

    images.forEach((image) => {
        image.classList.add(className);
        washingWrapperCardTop.classList.add(className);
    });
});


